import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Helmet } from "react-helmet-async";
import { useParams } from "react-router-dom";
import TwoColumnLayOut from "../../../layouts/two-columns/two-column-layout"
import { retrievePageMenu } from "../../../redux/slice/page-menu.slice";
import { RootState, useAppDispatch } from "../../../redux/store"
import LoadingComp from "../../../components/re-usable/loading/loading";


const SuppliersGuideSubPage = () => {
  const dispatch = useAppDispatch();
  const param = useParams();
  const path = `Resources%2FSuppliers-Guide%2F${param.pageName}`;
  const { RapsEuropeData } = useSelector((state: RootState) => state.rapsEurope);

  useEffect(() => {
    dispatch(retrievePageMenu(`%2F${path}`));
  }, [dispatch]);

  // Page published check
  const [isPublished, setIsPublished] = useState(false);

  useEffect(() => {
    if (RapsEuropeData[0]?.result !== undefined) {
      setIsPublished(true);
    }
  }, [RapsEuropeData]);

  if (!isPublished) return <LoadingComp />;
  // End Page published check

  return (
    <>
      <Helmet>
        <title>{RapsEuropeData[0]?.result[0]?.menuItemName}</title>
      </Helmet>
      <TwoColumnLayOut breadcrumbPath={path} isBreadcrumbpath={true} showAds={true}>
        <div dangerouslySetInnerHTML={{ __html: RapsEuropeData[0]?.result[0]?.description }}></div>
      </TwoColumnLayOut>
    </>
  );
}

export default SuppliersGuideSubPage;
